module.exports = __webpack_public_path__ + "img/ski_sub_title7.e5a5bf66.png";